import { ReactComponent as BitcoinIcon } from './bitcoin.svg';
import { ReactComponent as BitcoinIconDisabled } from './bitcoinDisabled.svg';
import { ReactComponent as EmailIcon } from './email.svg';

export const IconsPayoutMethods = {
  BitcoinIcon,
  BitcoinIconDisabled,
  EmailIcon,
};
